module.exports = __webpack_public_path__ + "media/VideoCompressed.1fc58cb9.mp4";